export default "---\ntitle: Device Hardware\n---\n\nThese terms and technologies are physical components of the GPU — the \"device\"\nin NVIDIA's lingo.\n"